<template>
    <div class="aside-menu-wrapper">
	    <div :class="['aside-menu',showMenu?'show':'']" @keyup.esc="close" @click.self="close">
		    <!--<div class="aside-menu-header">
			    <div class="search-input">
				    <el-input :placeholder="$t('search')" prefix-icon="el-icon-search" @input="search"></el-input>
			    </div>
			    &lt;!&ndash; <i class="close el-icon-close" @click="close"></i> &ndash;&gt;
		    </div>-->
		    <div class="aside-menu-menus">
			    <!--<span class="menu-link" :index="index+''" :key="item.code" v-for="(item,index) in realMenus"  :href="item.path" target="_blank">{{item.name}}</span>
			    <ul>
				    <li v-for="module in item">
					    <a class="menu-link" :key="module.code"   :href="module.path" target="_blank">{{module.name}}</a>
				    </li>
			    </ul>-->
			    <div v-for="(item,index) in realMenus" class="menus-modules">
				      <span class="title">{{$t(`menus.backend.${item.code}`)}}</span>
				      <ul class="modules">
					      <li v-for="module in item.backendModuleList" class="module">
						      <a :key="module.code"   :href="module.path" target="_blank">{{$t(`menus.backendModule.${module.code}`)}}</a>
					      </li>
				      </ul>
			    </div>
		    </div>
	    </div>
	    <div class="mask" @click="close" v-show="showMenu"></div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    export default{
        name:'asideMenu',
        props:{
            showMenu:{
                type:Boolean,
                required:true
            }
        },
        data(){
            return {
                realMenus:[]
            }
        },
        computed:mapState({
            menus:state => state.security.menus
        }),
        methods:{
            close(){
                this.$emit('close')
            },
            over(){
                this.$emit('over')
            },
            out(){
                this.$emit('out')
            },
            search(val){
              let menus = [...this.menus];
							menus.filter(item => {

							})
            }
        },
        created(){
                this.realMenus = this.menus
	              console.log(this.menus)
        }
    }
</script>

<style lang="scss" scoped>
    @import '~scss_vars';
    .aside-menu{
        position: absolute;
        z-index: 2222;
        top: 0;
        right: 0;
        box-sizing: border-box;
        width: 100%;
        height: 0;
        overflow: hidden;
        background-color: #fff;
        transition: all .2s linear;
    }
    .aside-menu.show{  
        height: auto;
        padding:6px 12px;    
        box-shadow: -1px 2px 8px 0 #bbb;
    }
    .mask{
	    position: absolute;
	    z-index: 1111;
	    top: 0;
	    right: 0;
	    box-sizing: border-box;
	    width: 100%;
	    height: 100%;
	    background-color: rgba(0,0,0,.7);
	    transition: all .2s linear;
    }
    .aside-menu-header{
        display: flex;
        /*justify-content: center;*/
        align-items: center;
        box-sizing: border-box;
        height: 5%;
        padding: 12px 144px;
        // background-color: $color-primary;
    }
    .aside-menu-menus{
        display: flex;
	    /*justify-content: center;*/
        flex-wrap: wrap;
        height: 95%;
        padding:12px 48px 24px 48px;
        overflow-y: auto;

        &::-webkit-scrollbar{
                width: 4px;
                height: 4px;
                background-color: transparent;
            }
       
        &::-webkit-scrollbar-thumb{
                border-radius: 10px;
                box-shadow: inset 0 0 6px rgba(0,0,0,.3);
                background-color: #ccc;
            }
    }
    .search-input{
        width: 240px;
        input{
            border-radius: 10px;
        }
    }
    .btn-close{
        flex: 2;
        display: flex;
        justify-content: flex-end;
    }
		.module{
				list-style: none;
				a{
					text-decoration: none;
					color:#111;
				}
		}
		.menus-modules{
			margin: 0 96px;
		}
		.modules{
			margin: 0;
			padding: 0;
		}
		.title{
			font-size: 22px;
			font-weight: 500;
			line-height: 48px;
		}
		.module{
			font-size: 16px;
			line-height: 32px;
			&:hover{
				cursor: pointer;
				color:$color-primary
			}
		}
</style>
<i18n>
    {
    "id":{
      "search":"search"
    },
    "zhCn":{
      "search":"搜索菜单"
    }
  }
</i18n>


// WEBPACK FOOTER //
// asideMenu.vue?198eda7c